"use strict";
/*!
 * React Contain Textbox <https://github.com/smujmaiku/react-contain-textbox>
 * Copyright(c) 2020 Michael Szmadzinski
 * MIT Licensed
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerHeight = void 0;
const react_1 = require("react");
function getInnerHeight(el) {
    const style = window.getComputedStyle(el);
    const paddingTop = parseInt(style.paddingTop) || 0;
    const paddingBottom = parseInt(style.paddingBottom) || 0;
    return el.clientHeight - (paddingTop + paddingBottom);
}
exports.getInnerHeight = getInnerHeight;
function useContain(ref, props = {}) {
    const { min = 0, max = Infinity, resolution = 1, } = props;
    const root = ref === null || ref === void 0 ? void 0 : ref.current;
    const updateSize = react_1.useCallback(() => {
        if (!root)
            return;
        const innerHeight = getInnerHeight(root);
        let maxSize = Math.min(max, innerHeight);
        root.style.fontSize = `${maxSize.toFixed(resolution)}px`;
        let minSize = Math.max(min, maxSize * innerHeight / root.scrollHeight);
        while (minSize + 1 / (10 ** resolution) < maxSize) {
            const size = (minSize + maxSize) / 2;
            root.style.fontSize = `${size.toFixed(resolution)}px`;
            if (root.scrollHeight > innerHeight) {
                maxSize = size;
                minSize = Math.max(maxSize * innerHeight / root.scrollHeight, minSize);
            }
            else {
                minSize = size;
            }
        }
        root.style.fontSize = `${minSize.toFixed(resolution)}px`;
    }, [root, min, max, resolution]);
    react_1.useEffect(() => {
        if (!root)
            return;
        let offsetWidth = 0;
        let offsetHeight = 0;
        let timer;
        const handleFrame = () => {
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(handleFrame);
            if (root.offsetWidth !== offsetWidth || root.offsetHeight !== offsetHeight) {
                offsetWidth = root.offsetWidth;
                offsetHeight = root.offsetHeight;
                updateSize();
            }
        };
        handleFrame();
        return () => {
            cancelAnimationFrame(timer);
        };
    }, [root, updateSize]);
    return updateSize;
}
exports.default = useContain;
